import { OptionItem } from '@nv/react-akira'
import * as Yup from 'yup'
import { COUNTRY_CODES } from '@nv/react-commons/src/Constants'
import { parsePhoneNumber } from 'awesome-phonenumber'
import { SIGNUP_METHOD } from '../SignUpWrapper/SignUpWrapper.constants'

export const LOGIN_METHOD_OPTIONS: OptionItem<SIGNUP_METHOD>[] = [
  { value: SIGNUP_METHOD.EMAIL, text: 'email_address' },
  { value: SIGNUP_METHOD.PHONE, text: 'phone_number' }
]

export const LOGIN_WITH_EMAIL_SCHEMA = Yup.object({
  email: Yup.string()
    .trim()
    .email('email_address_invalid')
    .required('email_address_required'),
  password: Yup.string().required('password_required')
})

export const LOGIN_WITH_PHONE_SCHEMA = Yup.object({
  countryCode: Yup.object({
    value: Yup.string().required('country_code_required')
  }),
  phoneNumber: Yup.string()
    .trim()
    .required('phone_number_required')
    .test('valid-phone-number', 'phone_number_format', function test (value) {
      const country = this.parent.countryCode?.value
      const pn = parsePhoneNumber(value, { regionCode: country })
      return pn.valid && pn.countryCode === parseInt(COUNTRY_CODES[country.toUpperCase()].replace('+', ''))
    }),
  country: Yup.object({
    value: Yup.string().required('country_is_required')
  })
})
